/**
 * Обов'язковість поля з правила між полями (FLD-38; field-rules.md, розд. 3.4): правило рівня
 * `error`, біля поля `X`, з умовою рівно `{ field: X, op: 'is_null' }` — те саме, що прапорець
 * `required` поля, лише з областю (`write` чи `create`) і, можливо, винятком `unless`. З нього форма
 * бере позначку обов'язковості, а перевірки накладок — заборону сховати поле (contacts.md, розд. 4.1:
 * ім'я контакту тримає правило `named`, а не `required`). Інші умови обов'язковості не означають:
 * їх рахує оцінювач правил. Без zod — лежить у чанку форми.
 */

/** Те з правила, що потрібне перевірці: опис DAL, оголошення маніфесту чи правило `/meta`. */
export interface RequirementRuleShape {
  readonly level: string;
  readonly on?: string | undefined;
  readonly field?: string | null | undefined;
  readonly violation?: unknown;
  /** `false` — правило не діє; `/meta` віддає лише активні, тож там поля немає. */
  readonly active?: boolean | undefined;
}

/** Поле, яке правило робить обов'язковим, і область; правило іншої форми — `null`. */
export interface RuleRequiredField {
  readonly field: string;
  readonly on: 'write' | 'create';
}

export function ruleRequiredField(rule: RequirementRuleShape): RuleRequiredField | null {
  if (rule.active === false || rule.level !== 'error') return null;
  const on = rule.on ?? 'write';
  if (on !== 'write' && on !== 'create') return null;
  const { field, violation } = rule;
  if (typeof field !== 'string' || typeof violation !== 'object' || violation === null) return null;
  const keys = Object.keys(violation);
  const condition = violation as { field?: unknown; op?: unknown };
  if (keys.length !== 2 || condition.field !== field || condition.op !== 'is_null') return null;
  return { field, on };
}
